import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {PerfilComponent} from "../perfil/perfil.component";

@Component({
    selector: 'app-perfil-list',
    templateUrl: './perfil-list.component.html',
    styleUrls: ['./perfil-list.component.css']
})
export class PerfilListComponent extends PerfilComponent implements OnInit{

    perfilsys:any;

    ngOnInit() {
		if (!this.isAdmin())
            this.router.navigateByUrl('inicio');
		else
			this.perfilService.get().then((resp) => this.perfilsys = (resp));
    }


    search() {
        let data = new Object();
        data['value'] = this.value;
        this.perfilService.search(data).then((resp) => this.perfilsys = (resp));
    }
}



// WEBPACK FOOTER //
// ./src/app/perfil-list/perfil-list.component.ts